<template>
	<v-dialog v-model="returnPrevention">
		<v-card>
			<v-card-title
				class="text-h5 bg-grey-lighten-2"
				primary-title
			>
				<h3>
					<translate>
						Your completed answers indicate the device has a software problem. Often, you can
						fix a lot of software problems yourself with a few easy steps! That way you won’t have
						to send your device away for repairs and be unreachable for a while!
					</translate>
				</h3>
			</v-card-title>

			<v-card-text>
				<h4>
					<translate>Step</translate>
					1
				</h4>
				<hr>
				<!-- eslint-disable-next-line vue/no-v-html value not injected, so it's safe-->
				<p v-html="$gettext('A lot of problems can be solved by a software update. You should check if there\'s a software update available for your device. We’ve explained exactly how to do this is in a video. You’ll find the video for your device by going to <a href=\'http://www.belsimpel.nl\'>Belsimpel</a> and searching for the name of your product. Then you scroll down to <strong>Tips and Tricks</strong> in the page, and choose the icon that says <strong>Software Update.</strong>')" />
				<p>
					<translate>The name of your device is</translate>
					: <strong>{{ row.phoneModel }}</strong>
				</p>
				<p>
					<translate>Did this not work? Then go to step</translate>
					2:
				</p>
				<h4>
					<translate>Step</translate>
					2
				</h4>
				<hr>
				<!-- eslint-disable-next-line vue/no-v-html value not injected, so it's safe-->
				<p v-html="$gettext('About 60% of problems can be solved by resetting your device. First, try switching off your device and then switching it on again. Did this not help? In that case, you should reset your device via the settings menu by returning your device back to the factory settings. Please note: this deletes all your files, so please save a back-up if you want to keep these. You can find exactly how to make a back-up of your device and reset it on <a href=\'https://www.belsimpel.nl/retourprocedure#backupreset\'>this page from Belsimpel</a>. Are you unable to reset your phone because of issues like a broken screen? In that case, you can skip this step.')" />
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-layout
					wrap
					align-center
					justify-space-around
				>
					<v-flex
						xs12
						md6
						class="text-center"
					>
						<v-btn
							class="padded-button"
							@click="closeClaimForm"
						>
							<translate>My device works properly again</translate>
						</v-btn>
					</v-flex>
					<v-flex
						xs12
						md6
						class="text-center"
					>
						<v-btn
							color="primary"
							class="padded-button"
							@click="() => returnPrevention = false"
						>
							<translate>I want to file a claim after all</translate>
						</v-btn>
					</v-flex>
				</v-layout>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
export default {
	name: 'ClaimFormDialog'
};
</script>
